export const MEMBER_INVITE_VALIDITY_HOURS = 48;

export function createMemberInviteExpiry(now = new Date()) {
  return new Date(now.getTime() + MEMBER_INVITE_VALIDITY_HOURS * 60 * 60 * 1000);
}

export function formatInviteExpiry(expiresAt: string | Date, now = new Date()) {
  const expiry = expiresAt instanceof Date ? expiresAt : new Date(expiresAt);
  if (Number.isNaN(expiry.getTime())) {
    return { absolute: 'Expiry unavailable', relative: 'Expiry unavailable' };
  }

  const remainingMinutes = Math.max(0, Math.ceil((expiry.getTime() - now.getTime()) / 60_000));
  const days = Math.floor(remainingMinutes / 1_440);
  const hours = Math.floor((remainingMinutes % 1_440) / 60);
  const minutes = remainingMinutes % 60;
  const parts = [days ? `${days}d` : '', hours ? `${hours}h` : '', !days && minutes ? `${minutes}m` : ''].filter(Boolean);

  return {
    absolute: new Intl.DateTimeFormat('en-AU', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: 'numeric',
      minute: '2-digit',
      timeZone: 'Australia/Sydney',
      timeZoneName: 'short',
    }).format(expiry),
    relative: remainingMinutes > 0 ? `Expires in ${parts.join(' ')}` : 'Expired',
  };
}
